import React from 'react';
import { Box } from '@mui/material';
import { getInitials, tintForName } from './uiHelpers';

interface InitialsAvatarProps {
  name: string | undefined | null;
  size?: number;
  // 'circle' for people, 'rounded' for groups.
  shape?: 'circle' | 'rounded';
  // Brand gradient fill instead of the per-name tint (profile, group hero).
  gradient?: boolean;
}

export const InitialsAvatar = ({ name, size = 30, shape = 'circle', gradient }: InitialsAvatarProps) => {
  const { tint, ink } = tintForName(name);
  return (
    <Box
      component="span"
      aria-hidden
      sx={{
        width: size,
        height: size,
        flex: 'none',
        borderRadius: shape === 'circle' ? '999px' : `${Math.round(size * 0.25)}px`,
        fontSize: Math.max(10, Math.round(size * 0.36)),
        fontWeight: 600,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: gradient ? 'var(--grad)' : tint,
        color: gradient ? '#fff' : ink,
      }}
    >
      {getInitials(name)}
    </Box>
  );
};
